import { addDoc, limit, query, where } from "firebase/firestore";
import {
  toDocumentData,
  getCollectionRef,
  onCollectionSnapshot,
  getDocumentRef,
  updateDocument,
  fromDocumentData,
} from "./FirebaseRepository";
import CompanyModel from "../models/CompanyModel";

class CompanyRepository {
  private path = "company";

  public async addCompanyToDataBase(data: CompanyModel): Promise<string> {
    const collection = getCollectionRef(this.path, converter);
    const doc = await addDoc(collection, data);
    return doc.id;
  }

  public updateCompanyOnDataBase(
    uid: string,
    updatedData: Partial<CompanyModel>
  ) {
    const doc = getDocumentRef(this.path, uid);
    const data = converter.toFirestore(updatedData);
    return updateDocument(doc, data);
  }

  addCompanyDocumentSnapshot(
    userUid: string,
    onChange: (data?: CompanyModel) => void
  ) {
    const collection = getCollectionRef(this.path, converter);
    const queryRef = query(
      collection,
      where(`users.${userUid}`, "<", 3),
      limit(1)
    );
    return onCollectionSnapshot<CompanyModel>(
      queryRef,
      (data) => onChange(data.length ? data[0] : undefined),
      (data) => onChange(data.length ? data[0] : undefined),
      () => onChange(undefined),
      (error) => console.error("CompanySnapshot", error)
    );
  }
}

// Firestore data converter
const converter = {
  toFirestore: (company: Partial<CompanyModel>) => {
    const data = company instanceof CompanyModel ? company.toSave() : company;
    return toDocumentData(data);
  },
  fromFirestore: (snapshot, options) => {
    let data = snapshot.data(options);
    data = fromDocumentData(data);
    return CompanyModel.create(snapshot.id, data);
  },
};

export default new CompanyRepository();
